import {
  DefaultButton,
  MaskedInput,
  NewModal,
  Select,
  Table,
} from 'components/index'
import { useContext, useRef, useState } from 'react'
import { Form } from '@unform/web'
import { UserContext } from 'context/userContext'
import { Icon } from 'assets/index'
import { ConfirmModal, selectOptions } from './factory'
import { Button, Content, FormContainer } from './style'

const NovoResgate = () => {
  const { data } = useContext(UserContext)
  const [dataInfo, setDataInfo] = useState<any>({})
  const formRef = useRef<HTMLFormElement | any>(null)
  const [confirModal, setConfirmModal] = useState(false)
  const [confirm, setConfirm] = useState()
  const handleSubmit = () => {
    console.log('kkk')
  }

  return (
    <FormContainer>
      <Form ref={formRef} onSubmit={() => console.log('submit')}>
        <div className="new-token-container">
          <MaskedInput
            smallPad
            type="money"
            handleChange={(e: any) => {
              setDataInfo((oldValue: any) => ({
                ...oldValue,
                value: e,
              }))
            }}
            placeholder="Valor do resgatado"
            name="value"
            defaultValue={dataInfo?.value}
          />
          <MaskedInput
            smallPad
            type="money"
            handleChange={(e: any) => {
              setDataInfo((oldValue: any) => ({
                ...oldValue,
                tax: e,
              }))
            }}
            placeholder="Taxas e multas"
            name="tax"
            defaultValue={dataInfo?.tax}
          />
          <MaskedInput
            smallPad
            disabled
            type="text"
            handleChange={(e: any) => console.log(e)}
            placeholder="Saldo do resgate"
            name="total"
            defaultValue={dataInfo?.total}
          />
        </div>
        <h4 className="detalhes-captacao-subtitle">Negociação do Resgate</h4>
        <div className="new-token-container">
          <div
            className="new-token-div-juros"
            style={{ justifyContent: 'flex-start', width: 'auto' }}
          >
            <MaskedInput
              smallPad
              large
              type="number"
              handleChange={(e: any) => {
                setDataInfo((oldValue: any) => ({
                  ...oldValue,
                  deadline: e,
                }))
              }}
              placeholder="Prazo do contrato"
              name="deadline"
              defaultValue={dataInfo?.deadline}
            />
            <span className="new-token-plus" style={{ marginLeft: 10 }}>
              meses
            </span>
          </div>
          <div
            className="new-token-div-juros"
            style={{ justifyContent: 'flex-start', width: 'auto' }}
          >
            <MaskedInput
              smallPad
              xxsmall
              type="jurosaa"
              handleChange={(e: any) => {
                setDataInfo((oldValue: any) => ({
                  ...oldValue,
                  profitability: e,
                }))
              }}
              placeholder="Juros"
              name="profitability"
              defaultValue={dataInfo?.profitability}
            />
            <span className="new-token-plus" style={{ marginLeft: 10 }}>
              % a.a.
            </span>
          </div>

          <Select
            // disabled={notUperLevel}
            placeholder="Período de cotização de saída"
            name="cotizationOut"
            options={selectOptions.cotizationOut}
            onChange={(e: any) => {
              setDataInfo((oldValue: any) => ({
                ...oldValue,
                cotizationOut: e,
              }))
            }}
            value={dataInfo?.cotizationOut}
          />
          <Select
            // disabled={notUperLevel}
            placeholder="Cotização de saída rentabilizada"
            name={'isCotizationProfitable'}
            options={selectOptions.isCotizationProfitable}
            onChange={(e: any) => {
              setDataInfo((oldValue: any) => ({
                ...oldValue,
                isCotizationProfitable: e,
              }))
            }}
            value={dataInfo?.isCotizationProfitable}
          />
        </div>
        <h4 className="detalhes-captacao-subtitle">
          Saldo Restante do investimento
        </h4>
        <div className="new-token-container">
          <MaskedInput
            smallPad
            disabled
            type="text"
            handleChange={(e: any) => console.log(e)}
            placeholder="Valor investido"
            name="total"
            defaultValue={data?.contract?.invested}
          />
          <MaskedInput
            smallPad
            disabled
            type="text"
            handleChange={(e: any) => console.log(e)}
            placeholder="Qauntidade de cotas"
            name="total"
            defaultValue={data.contract?.quotaAmount}
          />
        </div>
      </Form>
      <DefaultButton
        $loading={false}
        onClick={() => setConfirmModal(true)}
        style={{ marginTop: 24 }}
      >
        Solicitar
      </DefaultButton>
      <NewModal
        showModal={confirModal}
        height="40%"
        width="60%"
        setShowModal={setConfirmModal}
        noCloseButton
        padding={'30px'}
      >
        {/* <Table
          data={tableRows(filteredNames)}
          width={`1297px`}
          header={[
            '#',
            'DATA',
            'VALOR DO RESGATE',
            'TAXAS E MULTAS',
            'SALDO DO RESGATE',
            'STATUS',
            'CONTRATO',
          ]}
        /> */}
        <div />
        {/* [<ConfirmModal setConfirmModal={setConfirmModal} handleSubmit={handleSubmit}  />] */}
        {/* <Content>
          <div className="row">
            <p className="big-red-title">Migrar Contrato</p>
          </div>
          <p className="black-title">
            Tem certeza que quer realizar esta ação?
          </p>
          <p className="black-content">
            Você está preste a realizar um resgate neste contrato de forma
            definitiva.
          </p>
          <div className="row" style={{ justifyContent: 'space-between' }}>
            <Button onClick={() => setConfirmModal(false)}>
              <img src={Icon('x.svg')} alt="close modal" className="icon" />
              <p>Cancelar</p>
            </Button>
            <div style={{ marginLeft: 40 }}>
              <Button yellow onClick={() => handleSubmit()}>
                <img
                  src={Icon('check.svg')}
                  alt="conf modal"
                  className="icon"
                />
                <p>Confirmar</p>
              </Button>
            </div>
          </div>
        </Content> */}
      </NewModal>
    </FormContainer>
  )
}

export default NovoResgate
